import axios from "axios";
import { msalInstance } from "../../index";
import { getAccessTokenWithScope } from "../helper/helperFunctions";

export const AXIOS = axios.create();

let setAuthFn = null;

export const registerAuthSetterForAxios = (actualSetterFn) => {
  setAuthFn = actualSetterFn; // storing the reference of context's setAuth fn
};

let refreshPromise = null; // shared promise to avoid multiple refresh calls

async function refreshToken() {
  try {
    console.log("Proactively refreshing token...");
    const accounts = msalInstance.getAllAccounts();

    if (accounts.length) {
      const freshToken = await getAccessTokenWithScope(
        msalInstance,
        accounts[0]
      );

      if (freshToken?.accessToken) {
        // Keep both state and storage in sync
        localStorage.setItem("auth", JSON.stringify(freshToken));

        if (typeof setAuthFn === "function") {
          setAuthFn(freshToken);
        }

        console.log("Token refreshed!!");
        return freshToken;
      }
    }

    throw new Error("No accounts found for token refresh");
  } catch (err) {
    console.error("Proactive token refresh failed:", err);
    throw err;
  } finally {
    refreshPromise = null; // clear lock for future refreshes
  }
}

/*
Axios Request Configuration:
1: Appends the request header with access token by default
2: Refreshes the access token proactively when the current token expires in next 5 mins;
   If the token is already expired it will re-fetch new token updates the states and local storage and make the req call. 
*/
AXIOS.interceptors.request.use(async (config) => {
  let auth = JSON.parse(localStorage.getItem("auth"));

  if (auth?.accessToken) {
    const now = Date.now();
    const expiresAt = new Date(auth.expiryTime).getTime();

    const willExpireSoon = expiresAt - now < 5 * 60 * 1000;

    if (willExpireSoon) {
      // If token refresh not already in progress, start it
      if (!refreshPromise) {
        refreshPromise = refreshToken();
      }

      auth = await refreshPromise;
    }

    // Always appends latest valid token
    config.headers.Authorization = `Bearer ${auth.accessToken}`;
  }

  return config;
});
